import React from 'react';
import get from 'lodash/get';
import {ErrorMessage, FastField} from 'formik';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';
import Error from '../Error';
import PlusButton from './editor/PlusButton';
import MinusButton from './editor/MinusButton';

const SurveyConsoleButtonsType = ({form, name, push, remove}) => {
    const values = get(form.values, name) || [];
    const addItem = React.useCallback(() => {
        push({url: '', label: ''});
    }, [push]);
    return (
        <table className="table table-sm table-borderless">
            <colgroup>
                <col />
                <col />
                <col style={{width: 50}} />
            </colgroup>
            <thead>
                <tr>
                    <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.consoleButtons.label} /></th>
                    <th><FormattedMessage {...messages.surveys.form.label.consoleButtons.url} /></th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {values.map((item, index) => (
                    <tr key={index}>
                        <td className="pl-0">
                            <FastField id={`${name}.${index}.label`} name={`${name}.${index}.label`} type="text" maxLength="30"
                                className={classNames('form-control',
                                    {error: get(form.errors, `${name}.${index}.label`) && get(form.touched, `${name}.${index}.label`)})} />
                            <ErrorMessage name={`${name}.${index}.label`}>
                                {(message) => <Error reason={message.key} reasonParams={message.params} />}
                            </ErrorMessage>
                        </td>
                        <td>
                            <FastField id={`${name}.${index}.url`} name={`${name}.${index}.url`} type="url"
                                className={classNames('form-control',
                                    {error: get(form.errors, `${name}.${index}.url`) && get(form.touched, `${name}.${index}.url`)})} />
                            <ErrorMessage name={`${name}.${index}.url`}>
                                {(message) => <Error reason={message.key} reasonParams={message.params} />}
                            </ErrorMessage>
                        </td>
                        <td>
                            <div className="d-flex justify-content-center">
                                <div className="flex-column">
                                    <MinusButton remove={remove} index={index} />
                                </div>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan="4" className="pl-0">
                        <PlusButton onClick={addItem}>
                            <FormattedMessage {...messages.surveys.form.label.consoleButtons.add} />
                        </PlusButton>
                    </td>
                </tr>
            </tfoot>
        </table>
    );
};

export default SurveyConsoleButtonsType;
